import { render, staticRenderFns } from "./RmsPassword.vue?vue&type=template&id=c62932a8&scoped=true"
import script from "./RmsPassword.vue?vue&type=script&lang=js"
export * from "./RmsPassword.vue?vue&type=script&lang=js"
import style0 from "./RmsPassword.vue?vue&type=style&index=0&id=c62932a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62932a8",
  null
  
)

export default component.exports